import { useEffect, useState } from 'react'

import { MediaCacheName } from '../../replicache/dviMedia'
import { getMediaFromCacheOrUrl } from '../../replicache/dviMedia/syncMediaOfInspectionWithCache'
import { InspectionMediaEntry } from '../../sdk'
import { EditMediaButtonCached } from './EditMediaButtonCached'
import { ImageBoxUI } from './MediaGallaryUI'

export const CachedImageBox = ({
  entry,
  parentId,
  inspectionId
}: {
  entry: InspectionMediaEntry
  parentId: string
  inspectionId: string
}) => {
  const [url, setUrl] = useState<string>()
  useEffect(() => {
    async function getCache() {
      const cache = await caches.open(MediaCacheName)
      const response = await getMediaFromCacheOrUrl(entry, cache)
      if (response?.ok) {
        const blob = await response.blob()
        setUrl(URL.createObjectURL(blob))
      }
    }
    getCache()
  }, [entry])
  return (
    <ImageBoxUI src={url} alt={entry.info!.description}>
      {url && (
        <EditMediaButtonCached
          parentId={parentId}
          mediaEntry={entry}
          inspectionId={inspectionId}
          url={url}
        />
      )}
    </ImageBoxUI>
  )
}
